"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AppBar_1 = require("./AppBar");

var Avatar_1 = require("./Avatar");

var Backdrop_1 = require("./Backdrop");

var Badge_1 = require("./Badge");

var BottomNavigation_1 = require("./BottomNavigation");

var BottomNavigationAction_1 = require("./BottomNavigationAction");

var Button_1 = require("./Button");

var ButtonBase_1 = require("./ButtonBase");

var Card_1 = require("./Card");

var CardActions_1 = require("./CardActions");

var CardContent_1 = require("./CardContent");

var CardHeader_1 = require("./CardHeader");

var CardMedia_1 = require("./CardMedia");

var Checkbox_1 = require("./Checkbox");

var Chip_1 = require("./Chip");

var CircularProgress_1 = require("./CircularProgress");

var Collapse_1 = require("./Collapse");

var CssBaseline_1 = require("./CssBaseline");

var Dialog_1 = require("./Dialog");

var DialogActions_1 = require("./DialogActions");

var DialogContent_1 = require("./DialogContent");

var DialogContentText_1 = require("./DialogContentText");

var DialogTitle_1 = require("./DialogTitle");

var Divider_1 = require("./Divider");

var Drawer_1 = require("./Drawer");

var ExpansionPanel_1 = require("./ExpansionPanel");

var ExpansionPanelActions_1 = require("./ExpansionPanelActions");

var ExpansionPanelDetails_1 = require("./ExpansionPanelDetails");

var ExpansionPanelSummary_1 = require("./ExpansionPanelSummary");

var FilledInput_1 = require("./FilledInput");

var FormControl_1 = require("./FormControl");

var FormControlLabel_1 = require("./FormControlLabel");

var FormGroup_1 = require("./FormGroup");

var FormHelperText_1 = require("./FormHelperText");

var FormLabel_1 = require("./FormLabel");

var Grid_1 = require("./Grid");

var GridList_1 = require("./GridList");

var GridListTile_1 = require("./GridListTile");

var GridListTileBar_1 = require("./GridListTileBar");

var Icon_1 = require("./Icon");

var IconButton_1 = require("./IconButton");

var Input_1 = require("./Input");

var InputAdornment_1 = require("./InputAdornment");

var InputLabel_1 = require("./InputLabel");

var LinearProgress_1 = require("./LinearProgress");

var List_1 = require("./List");

var ListItem_1 = require("./ListItem");

var ListItemAvatar_1 = require("./ListItemAvatar");

var ListItemIcon_1 = require("./ListItemIcon");

var ListItemSecondaryAction_1 = require("./ListItemSecondaryAction");

var ListItemText_1 = require("./ListItemText");

var ListSubheader_1 = require("./ListSubheader");

var Menu_1 = require("./Menu");

var MenuItem_1 = require("./MenuItem");

var MobileStepper_1 = require("./MobileStepper");

var Modal_1 = require("./Modal");

var NativeSelect_1 = require("./NativeSelect");

var Paper_1 = require("./Paper");

var Popover_1 = require("./Popover");

var Radio_1 = require("./Radio");

var Select_1 = require("./Select");

var Snackbar_1 = require("./Snackbar");

var SnackbarContent_1 = require("./SnackbarContent");

var Step_1 = require("./Step");

var StepButton_1 = require("./StepButton");

var StepConnector_1 = require("./StepConnector");

var StepContent_1 = require("./StepContent");

var StepIcon_1 = require("./StepIcon");

var StepLabel_1 = require("./StepLabel");

var Stepper_1 = require("./Stepper");

var SvgIcon_1 = require("./SvgIcon");

var Switch_1 = require("./Switch");

var Tab_1 = require("./Tab");

var Table_1 = require("./Table");

var TableBody_1 = require("./TableBody");

var TableCell_1 = require("./TableCell");

var TablePagination_1 = require("./TablePagination");

var TableRow_1 = require("./TableRow");

var TableSortLabel_1 = require("./TableSortLabel");

var Tabs_1 = require("./Tabs");

var Toolbar_1 = require("./Toolbar");

var Tooltip_1 = require("./Tooltip");

var Typography_1 = require("./Typography");

var overrides = {
  MuiAppBar: AppBar_1.overrides,
  MuiAvatar: Avatar_1.overrides,
  MuiBackdrop: Backdrop_1.overrides,
  MuiBadge: Badge_1.overrides,
  MuiBottomNavigation: BottomNavigation_1.overrides,
  MuiBottomNavigationAction: BottomNavigationAction_1.overrides,
  MuiButton: Button_1.overrides,
  MuiButtonBase: ButtonBase_1.overrides,
  MuiCard: Card_1.overrides,
  MuiCardActions: CardActions_1.overrides,
  MuiCardContent: CardContent_1.overrides,
  MuiCardHeader: CardHeader_1.overrides,
  MuiCardMedia: CardMedia_1.overrides,
  MuiCheckbox: Checkbox_1.overrides,
  MuiChip: Chip_1.overrides,
  MuiCircularProgress: CircularProgress_1.overrides,
  MuiCollapse: Collapse_1.overrides,
  MuiCssBaseline: CssBaseline_1.overrides,
  MuiDialog: Dialog_1.overrides,
  MuiDialogActions: DialogActions_1.overrides,
  MuiDialogContent: DialogContent_1.overrides,
  MuiDialogContentText: DialogContentText_1.overrides,
  MuiDialogTitle: DialogTitle_1.overrides,
  MuiDivider: Divider_1.overrides,
  MuiDrawer: Drawer_1.overrides,
  MuiExpansionPanel: ExpansionPanel_1.overrides,
  MuiExpansionPanelActions: ExpansionPanelActions_1.overrides,
  MuiExpansionPanelDetails: ExpansionPanelDetails_1.overrides,
  MuiExpansionPanelSummary: ExpansionPanelSummary_1.overrides,
  MuiFilledInput: FilledInput_1.overrides,
  MuiFormControl: FormControl_1.overrides,
  MuiFormControlLabel: FormControlLabel_1.overrides,
  MuiFormGroup: FormGroup_1.overrides,
  MuiFormHelperText: FormHelperText_1.overrides,
  MuiFormLabel: FormLabel_1.overrides,
  MuiGrid: Grid_1.overrides,
  MuiGridList: GridList_1.overrides,
  MuiGridListTile: GridListTile_1.overrides,
  MuiGridListTileBar: GridListTileBar_1.overrides,
  MuiIcon: Icon_1.overrides,
  MuiIconButton: IconButton_1.overrides,
  MuiInput: Input_1.overrides,
  MuiInputAdornment: InputAdornment_1.overrides,
  MuiInputLabel: InputLabel_1.overrides,
  MuiLinearProgress: LinearProgress_1.overrides,
  MuiList: List_1.overrides,
  MuiListItem: ListItem_1.overrides,
  MuiListItemAvatar: ListItemAvatar_1.overrides,
  MuiListItemIcon: ListItemIcon_1.overrides,
  MuiListItemSecondaryAction: ListItemSecondaryAction_1.overrides,
  MuiListItemText: ListItemText_1.overrides,
  MuiListSubheader: ListSubheader_1.overrides,
  MuiMenu: Menu_1.overrides,
  MuiMenuItem: MenuItem_1.overrides,
  MuiMobileStepper: MobileStepper_1.overrides,
  MuiModal: Modal_1.overrides,
  MuiNativeSelect: NativeSelect_1.overrides,
  MuiPaper: Paper_1.overrides,
  MuiPopover: Popover_1.overrides,
  MuiRadio: Radio_1.overrides,
  MuiSelect: Select_1.overrides,
  MuiSnackbar: Snackbar_1.overrides,
  MuiSnackbarContent: SnackbarContent_1.overrides,
  MuiStep: Step_1.overrides,
  MuiStepButton: StepButton_1.overrides,
  MuiStepConnector: StepConnector_1.overrides,
  MuiStepContent: StepContent_1.overrides,
  MuiStepIcon: StepIcon_1.overrides,
  MuiStepLabel: StepLabel_1.overrides,
  MuiStepper: Stepper_1.overrides,
  MuiSvgIcon: SvgIcon_1.overrides,
  MuiSwitch: Switch_1.overrides,
  MuiTab: Tab_1.overrides,
  MuiTable: Table_1.overrides,
  MuiTableBody: TableBody_1.overrides,
  MuiTableCell: TableCell_1.overrides,
  MuiTablePagination: TablePagination_1.overrides,
  MuiTableRow: TableRow_1.overrides,
  MuiTableSortLabel: TableSortLabel_1.overrides,
  MuiTabs: Tabs_1.overrides,
  MuiToolbar: Toolbar_1.overrides,
  MuiTooltip: Tooltip_1.overrides,
  MuiTypography: Typography_1.overrides
};
exports["default"] = overrides;